module.exports = {
      id: "video-whitebg-usage",
      viewBox: "0 0 44 44",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#video-whitebg",
      toString: function () {
        return this.url;
      }
    }